module.exports = __webpack_public_path__ + "static/media/desermalinowy.65e3a7ab.jpg";